// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__PAYGEmailsComponent__bold{font-weight:700}", "",{"version":3,"sources":["webpack://./../common/wni-ce/capabilities-react/wnice-capability-profileinfo-react/components/PAYGEmailsComponent/PAYGEmailsComponent.module.scss"],"names":[],"mappings":"AAAA,gCACI,eAAA","sourcesContent":[".bold {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bold": "app__PAYGEmailsComponent__bold"
};
export default ___CSS_LOADER_EXPORT___;
